const opSimNao = {
  SIM: 'S',
  NAO: 'N',
};

const opAtivoInativo = {
  TUDO: 0,
  ATIVO: 1,
  INATIVO: 2,
};

const opLayout = {
  DEFAULT: 0,
  MODAL: 1,
  AUTH_LOGIN: 2,
  AUTH_SIGNIN: 3,
  AUTH_FORGOT: 4,
  AUTH_REDEFINIR: 5,
};

const opNumeroAcesso = {
  PRIMEIRO: 1,
};

export const opTipoAcesso = {
  USUARIO: 0,
  ADMIN_PLATAFORMA: 1,
  ADMIN_EMPRESA: 2,
  CLIENTE: 3,
  TOKEN: 4,
  PRIMEIRO: 1,
};

export const opTipoDocumento = {
  CPF: 0,
  CNPJ: 1,
  EXT: 2,
};

export const opMascaraDocumento = {
  [opTipoDocumento.CPF]: '000.000.000-00',
  [opTipoDocumento.CNPJ]: '00.000.000/0000-00', // A1.B2C.3D4/E5F6-07
  [opTipoDocumento.EXT]: '00000000000000000000',
};

const opTipoAcao = {
  INTEGRACAO_CATALOGO: 0,
  INTEGRACAO_CONSULTA: 1,
  INTEGRACAO_SOLICITACAO: 2,
  INTEGRACAO_TOKEN: 3,
  PLATAFORMA: 9,
};

/** Empresa */
const opTipoEmpresa = {
  SERVICOS: 0,
  LOCADORA: 1,
  FABRICANTE: 2,
  ADMIN_PLATAFORMA: 3,
};

/** Catalogo */
const conCatalogoSituacao = {
  EM_DESENVOLVIMENTO: 0,
  AGUARDANDO_APROVACAO: 1,
  PUBLICADO: 2,
};

const opEmpresa = {
  ASSISTE: 1,
  DMB: 11,
  MEGATEC: 47,
  LIESS: 50,
  PICCIN: 13,
};

const opCatalogoTipoConversao = {
  MANUAL: 0,
  INTELIGENCIA_ARTIFICIAL: 1,
};

const opCatalogoTipoSequenciaPagina = {
  NAO_APLICADO: 0,
  DESENHO_TABELA: 1,
  TABELA_DESENHO: 2,
};

const opConferencia = {
  NAO_CONFERIDO: 0,
  CONFERIDO: 1,
};

const opSalvarRascunhoConfirmar = {
  SALVAR_RASCUNHO: 0,
  CONFIRMAR: 1,
};

const opConferenciaAtualNovo = {
  ATUAL: 0,
  NOVO: 1,
};

/** PaginaCatalogo */
const opPaginaCatalogoTipo = {
  DESENHO: 1,
  TABELA: 2,
  MISTO: 3,
  ELIMINADO: 4,
};

const opPaginaCatalogoSituacao = {
  CLASSIFICADO: 1,
  CONCLUIDO: 2,
  DESENHO_EDITADO: 3,
};

const opPaginaCatalogoOrientacao = {
  PORTRAIT: '0',
  LANDSCAPE: '1',
};

const opEditorAssociarTipoExtracao = {
  TRADICIONAL: 0,
  EASY_FAST: 1,
  EASY_DEEP: 2,
  PDF: 3,
  PADDLE_OCR: 4,
};

const opEditorTabelaTipoExtracao = {
  TRADICIONAL: 0,
  CONVENCIONAL_NODEJS: 1,
  EASY_FAST: 2,
  TABULA: 3,
  CAMELOT: 4,
  PDFPLUMBER: 5,
};

const opSolicitacaoSituacao = {
  SOLICITADO: 0,
  CANCELADO: 1,
  TODOS: 2,
};

const opTipoUpdateClassificacao = {
  ATUALIZA_PAGINA: 0,
  CLASSIFICADO: 1,
};

/** SVG */

const opDimensaoSvgGeradoCDI = {
  LARGURA_PAISAGEM: 874,
  ALTURA_PAISAGEM: 614,
  LARGURA_RETRATO: 614,
  ALTURA_RETRATO: 874,
};

/* =====================================================================
   MAPEAMENTO DE LINKS SOBRE O DESENHO (editor associar / Home)
   ---------------------------------------------------------------------
   Fonte única destas constantes. Antes existiam duas definições de
   LINK_FORM_TYPES com valores divergentes (lib/mapeamentoUtils.js tinha
   apenas { ocr: 2 } e components/EditorAI/index.js tinha
   { circle: 0, rect: 1, ocr: 2 }).

   opLinkForma  -> atributo data-id da forma principal do link
   opLinkRotulo -> atributo data-rotulo do elemento <a>
   opLinkPapel  -> atributo data-role dos elementos internos do link

   IMPORTANTE: os valores 0, 1 e 2 são LEGADOS e existem em todos os SVG
   já mapeados. Não podem ser renumerados.

   As formas foram escolhidas para sobreviver ao svgo do backend
   (shared/lib/svgo.ts): círculo, elipse, retângulo COM rx/ry, texto e
   path são preservados; polygon, line e retângulo SEM rx/ry são
   convertidos em path. Atributos data-* são preservados.
   ===================================================================== */

const opLinkForma = {
  /** legado: marcador circular com o código dentro */
  CIRCULO: 0,
  /** legado: marcador retangular com o código dentro */
  RETANGULO: 1,
  /** marcador temporário do OCR (nunca é salvo no arquivo) */
  OCR: 2,
  /** área desenhada por arraste sobre o contorno do componente */
  AREA: 3,
};

const opLinkRotulo = {
  /** código do item dentro da própria forma (comportamento legado) */
  CODIGO: 'codigo',
  /** sem texto: a descrição aparece no hover e na tabela */
  NENHUM: 'nenhum',
  /** balão externo com o código, ligado por linha de chamada */
  ETIQUETA: 'etiqueta',
};

const opLinkPapel = {
  AREA: 'area',
  CHAMADA: 'chamada',
  ROTULO: 'rotulo',
  ROTULO_TEXTO: 'rotulo-texto',
};

/**
 * Limites de tamanho por forma, em unidades do SVG (o canvas é fixo em
 * 874 x 614 ou 614 x 874 — ver opDimensaoSvgGeradoCDI).
 *
 * A área precisa de um mínimo menor que o dos marcadores legados para
 * cobrir componentes pequenos de esquemas elétricos, e de um máximo bem
 * maior para cobrir réguas de bornes inteiras.
 */
const opLinkTamanho = {
  [opLinkForma.CIRCULO]: { min: 5, max: 36 },
  [opLinkForma.RETANGULO]: { min: 5, max: 36 },
  [opLinkForma.AREA]: { min: 3, max: 400 },
};

/** aparência padrão da área e da etiqueta */
const opLinkEstilo = {
  COR: '#ff6d3c',
  COR_TEXTO: '#17263b',
  AREA_FILL_OPACITY: '0.12',
  ROTULO_FILL: '#fff',
  ROTULO_FILL_OPACITY: '0.95',
  ESPESSURA: '0.6',
  /**
   * NUNCA usar opacity 0 para "esconder" a área: o plugin
   * removeHiddenElems do svgo remove o elemento <a> inteiro, apagando o
   * mapeamento. Para área sem preenchimento use fill="none".
   */
  AREA_FILL_NONE: 'none',
};

/** Notificacao */
const opNotificacaoTipo = {
  BANNER: 0,
  PRIVADO: 1,
  CONFERENCIA: 2,
};

/** Sugestao */
const opSugestaoTipo = {
  CRIACAO_FABRICANTE: '1',
  CRIACAO_MODELO: '2',
};

const opSugestaoStatus = {
  PENDENTE: 0,
  APROVADO: 1,
  REPROVADO: 2,
};

const opSugestaoOrigem = {
  CATALOGO_CRIACAO_FABRICANTE: -1000,
  CATALOGO_CRIACAO_MODELO: -1001,
};

/** Job */
const opJob = {
  EM_PROCESSAMENTO: '0',
  CONCLUIDO: '1',
  ERRO: '2',
};

export {
  opSimNao,
  opAtivoInativo,
  opLayout,
  opTipoAcao,
  opTipoEmpresa,
  conCatalogoSituacao,
  opEmpresa,
  opCatalogoTipoConversao,
  opCatalogoTipoSequenciaPagina,
  opConferencia,
  opSalvarRascunhoConfirmar,
  opConferenciaAtualNovo,
  opPaginaCatalogoTipo,
  opPaginaCatalogoSituacao,
  opPaginaCatalogoOrientacao,
  opEditorAssociarTipoExtracao,
  opEditorTabelaTipoExtracao,
  opSolicitacaoSituacao,
  opTipoUpdateClassificacao,
  opDimensaoSvgGeradoCDI,
  opLinkForma,
  opLinkRotulo,
  opLinkPapel,
  opLinkTamanho,
  opLinkEstilo,
  opNotificacaoTipo,
  opSugestaoTipo,
  opSugestaoStatus,
  opSugestaoOrigem,
  opJob,
  opNumeroAcesso,
};
